<div class="feAnnouncementModal feModal">
    <div class="feModalHeader">
        <span class="feModalTitle">{{announcement.modalTitle}}</span>
        <div class="feModalCloseButton">
            <span mat-dialog-close>Fermer</span>
            <mat-icon mat-dialog-close>close</mat-icon>
        </div>
    </div>
    <div class="announcementBody">
        <div class="announcementLeft">
            <div class="announcementIcon">
                <fe-icon [iconType]="announcement.icon" [color]="ColorType.white" [size]="32"/>
            </div>
            <span class="announcementHeadline">{{announcement.headline}}</span>
            <span class="announcementSubtitle">{{announcement.subtitle}}</span>
            <div class="announcementTimeline">
                <div *ngFor="let step of announcement.timeline" [class.active]="step.active">
                    <i></i>{{step.label}}
                </div>
            </div>
        </div>
        <div class="announcementRight">
            <p class="announcementText">{{text}}</p>
            <span class="littleText" *ngIf="getCommercialName()">
                Votre chargé d'affaires : <b>{{getCommercialName()}}</b>
                <ng-container *ngIf="salesPersonDetails.salesPersonPhone"> · {{salesPersonDetails.salesPersonPhone}}</ng-container>
            </span>
            <div class="announcementButtons">
                <fe-button type="TERTIARY" color="PRIMARY" text="Plus tard" mat-dialog-close/>
                <fe-button text="Contacter mon chargé d'affaires" (click)="askForContact()"/>
            </div>
        </div>
    </div>
</div>
